var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg97(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.8,21.49v7.44h2.54c0,0-0.04-1.74,1.59-1.85c0,0,1.66-0.05,1.65,1.85h10.89c0,0,0.02-1.77,1.66-1.86 c0,0,1.59,0.04,1.59,1.86h5.65v-7.44H21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.54,21.78v6.7l2.6,0.45h2.48c0,0,0.12-1.81,1.79-1.84c0,0,1.48,0.17,1.55,1.84h10.66v-7.44H0.68 C0.68,21.49,0.4,21.64,0.54,21.78z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.47,
    y: 22.45,
    fill: "currentColor",
    width: 3.55,
    height: 3.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.52,
    y: 23.44,
    fill: "currentColor",
    width: 3.55,
    height: 2.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.61,
    y: 22.45,
    fill: "currentColor",
    width: 5.63,
    height: 3.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.1,
    y: 22.45,
    fill: "currentColor",
    width: 3.65,
    height: 3.02
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.31,
    y: 22.45,
    fill: "currentColor",
    width: 3.65,
    height: 3.02
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.18,
    y: 23.39,
    fill: "currentColor",
    width: 3.65,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.25,
    y: 23.39,
    fill: "currentColor",
    width: 3.65,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 24.45,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 56.2867 -5.747)",
    fill: "currentColor",
    width: 5.65,
    height: 1.64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2,
    y: 24.45,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 58.2897 -7.7501)",
    fill: "currentColor",
    width: 5.65,
    height: 1.64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.32,
    y: 24.45,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 68.4124 -17.8728)",
    fill: "currentColor",
    width: 5.65,
    height: 1.64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.32,
    y: 24.45,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 70.4155 -19.8758)",
    fill: "currentColor",
    width: 5.65,
    height: 1.64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.18,
    y: 22.45,
    fill: "currentColor",
    width: 3.65,
    height: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.66,
    y: 24.24,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 71.2277 -22.2083)",
    fill: "currentColor",
    width: 4.13,
    height: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.25,
    y: 22.45,
    fill: "currentColor",
    width: 3.65,
    height: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.49,
    y: 24.46,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 35.5925 14.9531)",
    fill: "currentColor",
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.52,
    y: 24.46,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 37.6194 12.9262)",
    fill: "currentColor",
    width: 5.65,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.52,
    y: 22.45,
    fill: "currentColor",
    width: 3.55,
    height: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3,
    cy: 28.77,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 7.35,
    cy: 28.77,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.91,
    cy: 28.85,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 25.96,
    cy: 28.85,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.13,
    cy: 28.93,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 40.18,
    cy: 28.93,
    r: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.92,28.93H19.9c-0.07,0-0.13-0.06-0.13-0.13v-7.17c0-0.07,0.06-0.13,0.13-0.13h0.02c0.07,0,0.13,0.06,0.13,0.13v7.17 C20.05,28.87,19.99,28.93,19.92,28.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.44,28.93h-0.02c-0.07,0-0.13-0.06-0.13-0.13v-7.17c0-0.07,0.06-0.13,0.13-0.13h0.02c0.07,0,0.13,0.06,0.13,0.13v7.17 C20.57,28.87,20.51,28.93,20.44,28.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.96,28.93h-0.02c-0.07,0-0.13-0.06-0.13-0.13v-7.17c0-0.07,0.06-0.13,0.13-0.13h0.02c0.07,0,0.13,0.06,0.13,0.13v7.17 C21.09,28.87,21.03,28.93,20.96,28.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,28.93h-0.02c-0.07,0-0.13-0.06-0.13-0.13v-7.17c0-0.07,0.06-0.13,0.13-0.13h0.02c0.07,0,0.13,0.06,0.13,0.13v7.17 C21.63,28.87,21.57,28.93,21.5,28.93z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg97);
export default __webpack_public_path__ + "static/media/97.29b98021f79fdd31937e55ec3685a61f.svg";
export { ForwardRef as ReactComponent };